var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoals300(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rewards/goals-300") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 45 0 45 47.9999652 0 47.9999652"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 45 0 45 44.5217043 0 44.5217043"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "7.03125e-05 0 45 0 45 44.5217043 7.03125e-05 44.5217043"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Rewards-1440",
    transform: "translate(-743.000000, -681.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rewards/goals-300",
    transform: "translate(743.000000, 681.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,47.9999652 L22.5,47.9999652 C10.0736719,47.9999652 0,38.0333565 0,25.7390957 L0,4.17387826 C0,1.86883478 1.88894531,-3.47826087e-05 4.21875,-3.47826087e-05 L40.78125,-3.47826087e-05 C43.1110547,-3.47826087e-05 45,1.86883478 45,4.17387826 L45,25.7390957 C45,38.0333565 34.9263281,47.9999652 22.5,47.9999652",
    id: "Fill-1",
    fill: "#AD8D07",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,44.5217043 L22.5,44.5217043 C10.0736719,44.5217043 0,34.5550957 0,22.2608348 L0,4.17387826 C0,1.86883478 1.88894531,-3.47826087e-05 4.21875,-3.47826087e-05 L40.78125,-3.47826087e-05 C43.1110547,-3.47826087e-05 45,1.86883478 45,4.17387826 L45,22.2608348 C45,34.5550957 34.9263281,44.5217043 22.5,44.5217043",
    id: "Fill-4",
    fill: "#FFDC4A",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7813203,-3.47826087e-05 L4.21882031,-3.47826087e-05 C1.88901563,-3.47826087e-05 7.03125e-05,1.86883478 7.03125e-05,4.17387826 L7.03125e-05,22.2608348 C7.03125e-05,34.5550957 10.0737422,44.5217043 22.5000703,44.5217043 L22.5000703,44.5217043 C34.9263984,44.5217043 45.0000703,34.5550957 45.0000703,22.2608348 L45.0000703,4.17387826 C45.0000703,1.86883478 43.111125,-3.47826087e-05 40.7813203,-3.47826087e-05 M40.7813203,4.17387826 L40.7813203,22.2608348 C40.7813203,32.2340522 32.5804219,40.3477913 22.5000703,40.3477913 C12.4197188,40.3477913 4.21882031,32.2340522 4.21882031,22.2608348 L4.21882031,4.17387826 L40.7813203,4.17387826",
    id: "Fill-7",
    fill: "#D3AB05",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-10",
    stroke: "#AD8D07",
    strokeWidth: 4.17391304,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "32.2809258 14.937287 20.2887773 26.8019826 14.1251836 20.7038957"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoals300);
export default __webpack_public_path__ + "static/media/goals-300.aab6a5b717a12e09b865ea9282e130de.svg";
export { ForwardRef as ReactComponent };